// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.GraphicsDetailsModal-module__modal--Y4mH_ .full-width-modal-content{scrollbar-gutter:auto}.GraphicsDetailsModal-module__sidebar--JMWkO{display:flex;flex-direction:column;width:340px;height:100%;position:relative;max-height:calc(100vh - 133px);overflow:hidden auto;flex-shrink:0}.GraphicsDetailsModal-module__sidebarSections--WCMko{padding:5px 15px}.GraphicsDetailsModal-module__collapsed--sB9nb{visibility:collapse}.GraphicsDetailsModal-module__toggleButtonWrapper--rcmDD{background:var(--gray-2);height:100%;width:1px}.GraphicsDetailsModal-module__toggleButton--Np2Pg{position:absolute;z-index:10;top:90px;width:26px;height:26px;border-radius:100%;box-shadow:0 0 2px .5px rgba(0,0,0,.25);background-color:#fff;border:1px solid var(--gray-1);text-align:center;cursor:pointer}.GraphicsDetailsModal-module__toggleButton--Np2Pg:hover{background-color:var(--background-color)}.GraphicsDetailsModal-module__toggleButton--Np2Pg svg{margin-right:2px;margin-top:7px;transform:rotate(180deg)}.GraphicsDetailsModal-module__toggleButton--Np2Pg.GraphicsDetailsModal-module__toggleButtonCollapsed--_0vgn svg{transform:rotate(0deg);margin-right:0}.GraphicsDetailsModal-module__assetActions--q6ie4{display:flex;justify-content:space-between;top:30px;position:absolute;width:100%}.GraphicsDetailsModal-module__assetActions--q6ie4:before{content:"";width:55px}.GraphicsDetailsModal-module__assetActions--q6ie4 .GraphicsDetailsModal-module__iconsContainer--sxhNJ{display:flex;gap:5px;margin-bottom:10px}.GraphicsDetailsModal-module__assetActions--q6ie4 .GraphicsDetailsModal-module__iconWrapper--jilee{border:1px solid var(--gray-4);height:25px;width:25px;display:flex;align-items:center;justify-content:center;border-radius:15px;cursor:pointer;color:#fff}.GraphicsDetailsModal-module__assetActions--q6ie4 .GraphicsDetailsModal-module__iconWrapper--jilee svg{font-size:30px;color:var(--gray-5);width:13px;height:14px}.GraphicsDetailsModal-module__assetActions--q6ie4 .GraphicsDetailsModal-module__iconWrapper--jilee:hover{border-color:var(--gray-6)}.GraphicsDetailsModal-module__assetActions--q6ie4 .GraphicsDetailsModal-module__iconWrapper--jilee:hover svg{color:var(--gray-6)}.GraphicsDetailsModal-module__contentWrapper--Ca1HC{align-items:flex-end;background:#fff;display:flex;flex-direction:column;flex-grow:1;justify-content:center;padding:12px;position:relative;z-index:2;overflow:auto}.GraphicsDetailsModal-module__assetViewContainer--XYly7{align-items:center;display:inline-flex;height:100%;gap:12px;justify-content:space-between;overflow:hidden;width:100%}.GraphicsDetailsModal-module__assetContainer--XseAg{align-items:center;display:flex;justify-content:center;position:relative;min-width:200px;width:100%;height:100%;overflow:auto}.GraphicsDetailsModal-module__arrow--qrVcq{box-shadow:none !important;flex-shrink:0}.GraphicsDetailsModal-module__arrow--qrVcq circle{fill:var(--gray-1)}.GraphicsDetailsModal-module__arrow--qrVcq path{fill:var(--primary-color)}.GraphicsDetailsModal-module__arrow--qrVcq:hover circle{fill:var(--primary-color);transition:fill 300ms ease}.GraphicsDetailsModal-module__arrow--qrVcq:hover path{fill:#fff}.GraphicsDetailsModal-module__arrow--qrVcq:disabled path{fill:var(--gray-4)}.GraphicsDetailsModal-module__previousArrow--hmkNs{}.GraphicsDetailsModal-module__nextArrow--nVH_f{transform:rotate(180deg)}.GraphicsDetailsModal-module__content--FVCnl{height:100%;display:flex;width:100%}.GraphicsDetailsModal-module__titleExperimentName--teUyG{color:#8c95a8;margin-left:7px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dsPrimaryBlue": `#5155f5`,
	"dsSecondaryBlue": `#e5e5fe`,
	"dsHoverBlue": `#3438d0`,
	"dsClickBlue": `#262ab5`,
	"dsClickBlue2": `#d3d4f0`,
	"dsClickBlue3": `#a8a9e1`,
	"dsClickBlue4": `#7c7fd2`,
	"dsClickBlue5": `#5154c3`,
	"dsBlack": `#191a1c`,
	"dsGray1": `#f5f7fa`,
	"dsGray2": `#eaecf2`,
	"dsGray3": `#dce0ea`,
	"dsGray4": `#b3b9c8`,
	"dsGray5": `#8c95a8`,
	"dsGray6": `#5f677e`,
	"dsGray7": `#3d4355`,
	"dsGrayMainHeader": `#373d4d`,
	"dsGrayLine": `#e2e2e2`,
	"dsGrayBackground": `#f4f4f5`,
	"dsWhite": `#fff`,
	"dsWarning": `#f14668`,
	"dsSuccess": `#00d41f`,
	"dsActionYellow": `#f3b32a`,
	"dsActionYellowLight": `#fef7e7`,
	"dsChartGreen": `#19a979`,
	"dsChartPink": `#ed4a7b`,
	"dsChartYellow": `#f4b400`,
	"dsChartPurple": `#945fcf`,
	"dsChartTurquoise": `#12a4b4`,
	"dsChartBlue": `#525df4`,
	"dsChartOrange": `#fb9341`,
	"dsChartBurgundy": `#bf399e`,
	"dsChartRed": `#ef6868`,
	"dsChartGrey": `#6c8893`,
	"dsChartDarkBlue": `#2e6497`,
	"dsChartOrangeLight": `#feddc3`,
	"dsChartLightBlue": `#5899da`,
	"dsTeamProRed": `#ff594c`,
	"dsFreeYellow": `#ffb42e`,
	"dsTeamsGreen": `#52aea4`,
	"dsTableRowHover": `#f7f8fa`,
	"dsTableNegativeHighlight": `#ffeae9`,
	"dsTableNegativeHighlightHover": `#ffe0df`,
	"dsSparklinePurple": `#777af7`,
	"dsPrimaryBlue100": `#f3f4fe`,
	"dsPrimaryBlue200": `#cfd0ff`,
	"dsPrimaryBlue300": `#8889f8`,
	"dsPrimaryBlue400": `#6c6ff7`,
	"dsPrimaryBlue500": `#575af5`,
	"dsPrimaryBlue600": `#4449f3`,
	"dsPrimaryBlue700": `#3339f1`,
	"dsPrimaryBlue800": `#1f29ef`,
	"dsPrimaryBlue900": `#1823de`,
	"dsPrimaryBlue1000": `#151fcc`,
	"dsMainHeader100": `#f9f9fa`,
	"dsMainHeader200": `#b5b7bc`,
	"dsMainHeader300": `#91959d`,
	"dsMainHeader400": `#7b7f89`,
	"dsMainHeader500": `#6b6f7b`,
	"dsMainHeader600": `#5e6370`,
	"dsMainHeader700": `#545967`,
	"dsMainHeader800": `#4b505f`,
	"dsMainHeader900": `#434958`,
	"dsMainHeader1000": `#3d4252`,
	"dsWarning100": `#fcdce3`,
	"dsWarning200": `#f9b5c2`,
	"dsWarning300": `#f46d88`,
	"dsWarning400": `#e44262`,
	"dsWarning500": `#c83a56`,
	"dsWarning600": `#b2344d`,
	"dsWarning700": `#a02f45`,
	"dsWarning800": `#922a3f`,
	"dsWarning900": `#852639`,
	"dsWarning1000": `#792334`,
	"modal": `GraphicsDetailsModal-module__modal--Y4mH_`,
	"sidebar": `GraphicsDetailsModal-module__sidebar--JMWkO`,
	"sidebarSections": `GraphicsDetailsModal-module__sidebarSections--WCMko`,
	"collapsed": `GraphicsDetailsModal-module__collapsed--sB9nb`,
	"toggleButtonWrapper": `GraphicsDetailsModal-module__toggleButtonWrapper--rcmDD`,
	"toggleButton": `GraphicsDetailsModal-module__toggleButton--Np2Pg`,
	"toggleButtonCollapsed": `GraphicsDetailsModal-module__toggleButtonCollapsed--_0vgn`,
	"assetActions": `GraphicsDetailsModal-module__assetActions--q6ie4`,
	"iconsContainer": `GraphicsDetailsModal-module__iconsContainer--sxhNJ`,
	"iconWrapper": `GraphicsDetailsModal-module__iconWrapper--jilee`,
	"contentWrapper": `GraphicsDetailsModal-module__contentWrapper--Ca1HC`,
	"assetViewContainer": `GraphicsDetailsModal-module__assetViewContainer--XYly7`,
	"assetContainer": `GraphicsDetailsModal-module__assetContainer--XseAg`,
	"arrow": `GraphicsDetailsModal-module__arrow--qrVcq`,
	"previousArrow": `GraphicsDetailsModal-module__previousArrow--hmkNs GraphicsDetailsModal-module__arrow--qrVcq`,
	"nextArrow": `GraphicsDetailsModal-module__nextArrow--nVH_f GraphicsDetailsModal-module__arrow--qrVcq`,
	"content": `GraphicsDetailsModal-module__content--FVCnl`,
	"titleExperimentName": `GraphicsDetailsModal-module__titleExperimentName--teUyG`
};
module.exports = ___CSS_LOADER_EXPORT___;
